import { BusinessUnitsContract } from '@terra/shared-contracts-business-units';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const businessUnitsClient = createTerraOrpcClient({
  contract: BusinessUnitsContract,
  serviceName: SERVICE_NAME,
});
